import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Shared axios instance — sends the session_token httpOnly cookie on every request.
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Public endpoints
export const submitChallengeSignup = (payload) =>
  api.post("/challenge/signup", payload).then((r) => r.data);

export const submitContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

// Auth
export const exchangeSession = (sessionId) =>
  api
    .post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } })
    .then((r) => r.data);

export const fetchMe = () => api.get("/auth/me").then((r) => r.data);

export const logout = () => api.post("/auth/logout").then((r) => r.data);

// Admin
export const adminApi = {
  summary: () => api.get("/admin/summary").then((r) => r.data),

  listContacts: (params = {}) =>
    api.get("/admin/contacts", { params }).then((r) => r.data),
  resolveContact: (id, resolved = true) =>
    api.patch(`/admin/contacts/${id}/resolve`, null, { params: { resolved } }).then((r) => r.data),
  deleteContact: (id) => api.delete(`/admin/contacts/${id}`).then((r) => r.data),

  listSignups: (params = {}) =>
    api.get("/admin/signups", { params }).then((r) => r.data),
  deleteSignup: (id) => api.delete(`/admin/signups/${id}`).then((r) => r.data),

  listNotifications: (params = {}) =>
    api.get("/admin/notifications", { params }).then((r) => r.data),
  createNotification: (body) =>
    api.post("/admin/notifications", body).then((r) => r.data),
  updateNotification: (id, body) =>
    api.put(`/admin/notifications/${id}`, body).then((r) => r.data),
  deleteNotification: (id) => api.delete(`/admin/notifications/${id}`).then((r) => r.data),

  listReminders: (params = {}) =>
    api.get("/admin/reminders", { params }).then((r) => r.data),
  createReminder: (body) => api.post("/admin/reminders", body).then((r) => r.data),
  updateReminder: (id, body) =>
    api.put(`/admin/reminders/${id}`, body).then((r) => r.data),
  deleteReminder: (id) => api.delete(`/admin/reminders/${id}`).then((r) => r.data),
};
